<script lang="ts">
    let className: string = "";
    export {className as class};
    export let style: string = "";
</script>

<svg
        {style}
        class={className} 
   width="22.427082"
   zoomAndPan="magnify"
   viewBox="0 0 16.820312 16.820311"
   height="22.427082"
   preserveAspectRatio="xMidYMid meet"
   version="1.0"
   id="svg832"
   sodipodi:docname="Edit the road network(6).svg"
   inkscape:version="1.1.1 (c3084ef, 2021-09-22)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <defs
     id="defs836" />
  <sodipodi:namedview
     id="namedview834"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     showgrid="false"
     fit-margin-top="0"
     fit-margin-left="0"
     fit-margin-right="0"
     fit-margin-bottom="0"
     inkscape:zoom="0.6046875"
     inkscape:cx="241.44703"
     inkscape:cy="458.91473"
     inkscape:window-width="1920"
     inkscape:window-height="967"
     inkscape:window-x="0"
     inkscape:window-y="25"
     inkscape:window-maximized="1"
     inkscape:current-layer="svg832" />
  <path
     fill="#f9fbfd"
     d="m 16.179682,0.640621 c -0.20312,-0.20703 -0.4375,-0.36328 -0.70703,-0.47265 -0.26562,-0.11328 -0.54297,-0.16797 -0.83203,-0.16797 -0.28906,0 -0.5664,0.0547 -0.83594,0.16797 -0.26562,0.10937 -0.5039,0.26562 -0.70703,0.47265 l -0.96093,0.96094 3.08203,3.08203 0.96093,-0.96094 c 0.20704,-0.20703 0.36329,-0.4414 0.47266,-0.70703 0.11328,-0.26953 0.16797,-0.54687 0.16797,-0.83593 0,-0.28907 -0.0547,-0.56641 -0.16797,-0.83204 -0.10937,-0.26953 -0.26562,-0.5039 -0.47266,-0.70703 z m -1.83984,4.92188 -3.08203,-3.08203 -6.98047,6.97656 c -0.51953,0.51953 -0.88281,1.13281 -1.09375,1.83984 l -0.66406,2.23047 c -0.0703,0.23828 -0.0195,0.44141 0.15625,0.61719 0.17578,0.17578 0.3789,0.22656 0.61719,0.15625 l 2.23046,-0.66406 c 0.70704,-0.21094 1.32032,-0.57422 1.83985,-1.09766 z m 0,0"
     fill-opacity="1"
     fill-rule="nonzero"
     id="path828" />
  <path
     fill="#f9fbfd"
     d="m 2.492182,3.113281 c -0.32812,0 -0.64843,0.0664 -0.95312,0.19141 -0.30469,0.125 -0.57422,0.30468 -0.80859,0.53906 -0.23438,0.23437 -0.41407,0.5039 -0.53907,0.80859 -0.1289,0.30469 -0.1914000000002,0.625 -0.1914000000002,0.95313 v 8.72265 c 0,0.32813 0.0625,0.64844 0.1914000000002,0.95313 0.125,0.30469 0.30469,0.57422 0.53907,0.80859 0.23437,0.23438 0.5039,0.41406 0.80859,0.53906 0.30469,0.12891 0.625,0.19141 0.95312,0.19141 h 8.72266 c 0.32813,0 0.64844,-0.0625 0.95313,-0.19141 0.30468,-0.125 0.57421,-0.30468 0.80859,-0.53906 0.23437,-0.23437 0.41406,-0.5039 0.53906,-0.80859 0.125,-0.30469 0.19141,-0.625 0.19141,-0.95313 v -4.35937 c 0,-0.17188 -0.0625,-0.32031 -0.1836,-0.44141 -0.12109,-0.12109 -0.26953,-0.18359 -0.4414,-0.18359 -0.17188,0 -0.32031,0.0625 -0.44141,0.18359 -0.12109,0.1211 -0.17969,0.26953 -0.17969,0.44141 v 4.35937 c 0,0.16407 -0.0312,0.32422 -0.0977,0.47657 -0.0625,0.15234 -0.15235,0.28515 -0.26953,0.40234 -0.11719,0.11719 -0.25,0.20703 -0.40235,0.26953 -0.15234,0.0664 -0.3125,0.0977 -0.47656,0.0977 h -8.72266 c -0.16406,0 -0.32421,-0.0312 -0.47656,-0.0977 -0.15234,-0.0625 -0.28515,-0.15234 -0.40234,-0.26953 -0.11719,-0.11719 -0.20703,-0.25 -0.27344,-0.40234 -0.0625,-0.15235 -0.0937,-0.3125 -0.0937,-0.47657 v -8.72265 c 0,-0.16407 0.0312,-0.32422 0.0937,-0.47657 0.0664,-0.15234 0.15625,-0.28515 0.27344,-0.40234 0.11719,-0.11719 0.25,-0.20703 0.40234,-0.26953 0.15235,-0.0664 0.3125,-0.0977 0.47656,-0.0977 h 4.35938 c 0.17187,0 0.32031,-0.0586 0.44141,-0.17968 0.12109,-0.125 0.18359,-0.26954 0.18359,-0.44141 0,-0.17188 -0.0625,-0.32031 -0.18359,-0.44141 -0.1211,-0.12109 -0.26954,-0.18359 -0.44141,-0.18359 z m 0,0"
     fill-opacity="1"
     fill-rule="nonzero"
     id="path830" />
</svg>
